import { onMount, onDestroy } from "svelte";
import { browser } from "$app/environment";
import pkg from "crypto-js";
import stringify from "json-stable-stringify";
import { createSocket } from "$lib/client-data/ws.svelte.js";
import { diffApply } from "just-diff-apply";
const ws = createSocket("/ws");
/**
 * 页面处理推送及处理的通用逻辑，传入callback，就会执行自定义逻辑，通用逻辑是使用传入list，在收到推送后，更新list和推送的信息一样
 * 这里需要说明通用逻辑会返回信息hash值，如果hash和本地存储的不一样,说明ws有中断，有可能不对应服务端比较的对象，所以这种情况要通过fetch的方式
 * 去同步一下本地的信息.默认离开页面会自动取消订阅。但是返回值是取消订阅的方法，用于主动取消
 *
 * @export
 * @param {String} topic  推送主题，根据主题过滤推送的信息
 * @param {string} url fallback 同步地址
 * @param {object|array|any} data 要同步的数据对象或数组，data支持响应式
 * @param {{custom:(msg: {topic: string, hash: string, data: object|array}) => void,callBack:(object|array) => void}} callBack 可选回调，参数为同步后的数据,custom 可选回调，参数为推送的原始数据
 * @returns {Function} 取消订阅的方法
 */
export function usePush(topic, url, data, { custom, updateAfter, callBack } = {}) {
  if (!browser) return; //避免服务端执行
  let unSub;

  const updateData = (newData) => {
    if (Array.isArray(data) && Array.isArray(newData)) {
      data.length = 0;
      data.push(...newData); //  不换引用以支持响应式
    } else if (typeof data === "object" && typeof newData === "object") {
      Object.keys(data).forEach((k) => delete data[k]);
      Object.assign(data, newData); // 不换引用以支持响应式
    }
    updateAfter?.(newData);
  };

  onMount(() => {
    ws.send({ action: "sub", topic });
    unSub = ws.onMessage(async (msg) => {
      if (msg.topic !== topic) return;

      if (custom) return custom(msg);

      const hash1 = pkg.SHA256(stringify(data)).toString();

      if (hash1 === msg.hash) {
        diffApply(data, msg.data);
      } else {
        if (!url) return;
        const newData = await fetch(url).then((r) => r.json());
        if (newData) updateData(newData); // 响应式安全替换
      }
      if (callBack) return callBack(data);
    });
  });

  onDestroy(() => {
    if (!browser) return;
    ws.send({ action: "unsub", topic });
    unSub?.();
  });
  return unSub;
}
